const TokenKey = 'Auth-Token'
const UserId = 'UserId'
const RoleLevel = 'RoleLevel'

export function getToken() {
    if(window.localStorage)
        return window.localStorage.getItem(TokenKey)
    else
        return ""
}

export function setToken(token) {
    if(window.localStorage)
        window.localStorage.setItem(TokenKey, token)
}

export function removeToken() {
    if(window.localStorage)
        window.localStorage.removeItem(TokenKey)
}

export function getUserId() {
    if(window.localStorage)
        return window.localStorage.getItem(UserId)
    else
        return -1
}

export function setUserId(id) {
    if(window.localStorage)
        window.localStorage.setItem(UserId, id)
}

export function removeUserId() {
    if(window.localStorage)
        window.localStorage.removeItem(UserId)
}

export function getRoleLevel() {
    if(window.localStorage)
        return window.localStorage.getItem(RoleLevel)
    else
        return -1
}

export function setRoleLevel(id) {
    if(window.localStorage)
        window.localStorage.setItem(RoleLevel, id)
}

export function removeRoleLevel() {
    if(window.localStorage)
        window.localStorage.removeItem(RoleLevel)
}
